import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * Smart Hotels
 */
const factory = function factory({ window, document, thn }) {
    let onPurchaseEvent = null;
    let refreshPrice;
    return {
        generateSearchUrl(ctx) {
            const url = new URL(ctx.baseUrl);
            const validUrl = url.hostname.includes('ibe2.smarthotel');
            let hotelId = url.searchParams.get('id') ?? '';
            // https://ibe2.smarthotel.nl/?id=0e22a874-0588-4a9a-91dd-bc1788bcdf8b&arrival=2025-06-29&departure=2025-06-30&adults=2&children=0&ap=1
            if (!hotelId) {
                hotelId = url.pathname.split('/')[2] ?? '';
            }
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/\//g, '-');
            ctx.newData.dateEnd = ctx.data.dateEnd?.replace(/\//g, '-');
            url.searchParams.set('id', hotelId);
            url.searchParams.set('arrival', '[date_begin]');
            url.searchParams.set('departure', '[date_end]');
            url.searchParams.set('adults', '[adults]');
            url.searchParams.set('children', '[children]');
            url.searchParams.set('ap', (ctx?.data?.roomsDispo?.length?.toString() ?? '1'));
            url.pathname = '/';
            ctx.newUrl = url.toString();
            return ctx;
        },
        languageCheck(ctx) {
            const langDictionary = {
                Choose: 'en',
                Wählen: 'de',
                Kies: 'nl',
            };
            return new Promise((resolve, reject) => {
                const langKeyElement = document.querySelector('nav')?.textContent;
                let lang;
                if (langKeyElement) {
                    const langKey = Object.keys(langDictionary).find((key) => langKeyElement.includes(key));
                    if (langKey && langKey in langDictionary) {
                        lang = langDictionary[langKey];
                    }
                }
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
                reject(new Error('no_language'));
            });
        },
        boot() {
            const langContainer = document.querySelector('.list-none');
            const mainContainer = document.querySelector('#app');
            if (langContainer) {
                const refreshPage = thn.debounce(() => thn.languageCheck(), 800);
                thn.observeDom(langContainer, refreshPage, {
                    attributes: false,
                    childList: true,
                    subtree: true,
                });
                thn.shutdown(() => {
                    refreshPage.cancel();
                    thn.stopObserveDom(langContainer, refreshPage);
                });
            }
            if (mainContainer && !refreshPrice && thn.widgets.price.isTargetPage()) {
                refreshPrice = thn.debounce(() => {
                    const isLoading = thn.isVisible(document.querySelector('.overflow-hidden'));
                    if (!isLoading) {
                        thn.widgets.price.refresh().catch(() => { });
                    }
                }, 800);
                thn.observeDom(mainContainer, refreshPrice, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    characterData: true,
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(mainContainer, refreshPrice);
                        refreshPrice = null;
                    }
                });
            }
        },
        priceParseData() {
            // Guests, Adults & Children
            const guestSelector = document.querySelector('#roomOccupancyToggle > span.underline')?.textContent?.split(',');
            const adults = guestSelector?.[0] ? thn.parseNumber(guestSelector[0]) : 2;
            const childrenNumber = guestSelector?.[1] ? thn.parseNumber(guestSelector[1]) : 0;
            const infantsNumber = guestSelector?.[2] ? thn.parseNumber(guestSelector[2]) : 0;
            const children = (childrenNumber ?? 0) + (infantsNumber ?? 0);
            const childrenAges = [];
            for (let i = 0; i < children; i += 1) {
                childrenAges.push(10);
            }
            // Prices & Currency || No Rooms
            const prices = Array.from(document.querySelectorAll('.track-AddRoomToCart, .track-AddPackageToCart'));
            const currency = thn.parseCurrency(prices?.[0]?.textContent);
            const numericPrices = prices?.filter((el => thn.isVisible(el)))
                ?.map((el) => thn.parseNumber(el.textContent))
                ?.filter((value) => value !== null);
            const price = numericPrices.length > 0 ? Math.min(...numericPrices) : null;
            const noRooms = prices.length === 0;
            // Dates
            const dateSelector = Array.from(document.querySelectorAll('.notranslate'));
            const dateBegin = translateDate(dateSelector?.[0]?.textContent ?? '', thn.data.language) ?? '';
            const dateEnd = translateDate(dateSelector?.[1]?.textContent ?? '', thn.data.language) ?? '';
            const nights = thn.daysBetween(dateBegin, dateEnd);
            if (noRooms) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo: [{ adults: adults ?? 2, children, childrenAges }],
                    currency,
                    noRooms: true,
                };
            }
            if (!price) {
                return null;
            }
            if (price && currency && !noRooms) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo: [{ adults: adults ?? 2, children, childrenAges }],
                    price: price / nights,
                    currency,
                };
            }
            return null;
        },
        priceObserveDom(ctx) {
            const container = document.querySelector('main');
            if (container && !refreshPrice) {
                refreshPrice = thn.debounce(() => {
                    const isLoading = thn.isVisible(document.querySelector('overflow-hidden'));
                    if (!isLoading) {
                        ctx.widget.refresh().catch(() => { });
                    }
                }, 800);
                thn.observeDom(container, refreshPrice, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    characterData: true,
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(container, refreshPrice);
                        refreshPrice = null;
                    }
                });
            }
        },
        onStateChange: thn.debounce(() => {
            thn.pageCheck();
        }, 500),
        bookingObserveDom(ctx) {
            if (ctx.widget.isSet() || onPurchaseEvent) {
                return;
            }
            onPurchaseEvent = (message) => {
                if (message.event === 'purchase' && ctx.widget.setData().isSet()) {
                    ctx.widget.save();
                    if (onPurchaseEvent) {
                        thn.bus.detach('dataLayer:push', onPurchaseEvent);
                        onPurchaseEvent = null;
                    }
                }
            };
            thn.bus.on('dataLayer:push', onPurchaseEvent, true);
            thn.pageUnload(() => {
                if (onPurchaseEvent) {
                    thn.bus.detach('dataLayer:push', onPurchaseEvent);
                    onPurchaseEvent = null;
                }
            });
        },
        bookingParseData() {
            const bookingId = thn.dataLayerHelper.get('ecommerce')?.transaction_id;
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            // Guests, Adults & Children we don't grab it since it is not available in the dataLayer and the selectors are not reliable.
            // Dates
            const dateBegin = thn.dataLayerHelper.get('arrival_date')?.replace(/-/g, '/') ?? '';
            const dateEnd = thn.dataLayerHelper.get('departure_date')?.replace(/-/g, '/') ?? '';
            // Prices & Currency || No Rooms
            const price = thn.dataLayerHelper.get('price');
            const currency = thn.dataLayerHelper.get('currency');
            return {
                bookingId,
                dateBegin,
                dateEnd,
                price,
                currency,
            };
        },
    };
};

export { factory };
